<div class="about_route_planner">
    <h4>About route planner</h4>
    <div class="description">
        Our recommended routes help you get there safely and easily, and 
        they can even be tweaked to avoid traffic jams.
        If you spot a mistake or something that's missing, 
        <a href="https://www.theaa.com/help-support/routeplanner-feedback" rel="noopener noreferrer" target="_blank">please let us know.</a> 
        You can learn more in our
        <a href="https://www.theaa.com/terms-and-conditions/traffic-and-travel" rel="noopener noreferrer" target="_blank">Traffic and Travel Terms and Conditions.</a>
    </div>
</div>
